/**
 * The page header of the listings screen: title, subline, search and the
 * primary create action.
 *
 * The create button keeps the exact toggle semantics it had as a text link —
 * same handler, same caption logic — so opening and closing the editor below
 * behaves as before. Only its appearance changed.
 */
import React from "react";
import { Search } from "lucide-react";

export default function ListingsToolbar({
  query,
  onQueryChange,
  showForm,
  editingListingId,
  onToggleForm,
}) {
  const createLabel = showForm
    ? editingListingId
      ? "− Listing-Bearbeitung ausblenden"
      : "− Neues Listing ausblenden"
    : "+ Neues Listing anlegen";

  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        <h2 className="mb-1 text-[22px] font-bold text-foreground">Website Listings</h2>
        <p className="m-0 text-[13px] text-muted-foreground">
          Verwalte und erstelle Inserate für deine Website.
        </p>
      </div>

      {/* `min-w-0`, never `shrink-0`: the group already asks to wrap, but a
          group that may not shrink never gets narrow enough for wrapping to
          trigger, so it kept its single-line width (457px, 522px with the
          editor open) and pushed the whole page sideways on a phone. Letting
          it shrink is what makes both the wrap and the search field's
          `max-w-full` mean something. */}
      <div className="flex min-w-0 flex-wrap items-center gap-2">
        <div className="relative w-64 max-w-full">
          <Search
            aria-hidden="true"
            className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="search"
            aria-label="Listings durchsuchen"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Listings durchsuchen …"
            className="w-full rounded-lg border border-border bg-background py-2 pl-8 pr-3 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          />
        </div>

        <button
          type="button"
          onClick={onToggleForm}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {createLabel}
        </button>
      </div>
    </div>
  );
}
